import React from 'react';

export function Field({ label, value, onChange, options, multiline, ...props }) {
  const shared = {
    ...props, value: value ?? '', className: 'block w-full border rounded p-2',
    onChange: (event) => onChange(event.target.value),
  };
  return (
    <label className="block text-sm space-y-1">
      <span>{label}</span>
      {options ? (
        <select {...shared}>
          {Object.entries(options).map(([key, text]) => <option key={key} value={key}>{text}</option>)}
        </select>
      ) : multiline ? <textarea {...shared} /> : <input {...shared} />}
    </label>
  );
}

export function FormFields({ fields, value, onChange }) {
  return fields.map(([key, label, props = {}]) => (
    <Field key={key} label={label} value={value[key]} {...props}
      onChange={(next) => onChange({ ...value, [key]: next })} />
  ));
}
